var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "store-card-product" },
    [
      _c("media", {
        staticClass: "item-img",
        attrs: { media: _vm.media, width: "90", alt: _vm.model.name }
      }),
      _c("div", { staticClass: "item-title" }, [
        _vm._v("\n    " + _vm._s(_vm.model.name) + "\n    "),
        _c("span", [_vm._v("\n      " + _vm._s(_vm.model.code) + "\n    ")])
      ]),
      _c("div", { staticClass: "item-info" }, [
        _c("span", [_vm._v(_vm._s(_vm.color))]),
        _c("span", [_vm._v(_vm._s(_vm.size))]),
        _c("span", [_vm._v(_vm._s(_vm.product.amount) + " шт")])
      ]),
      _c("div", { staticClass: "item-prices" }, [
        _vm.isDiscount
          ? _c("div", { staticClass: "old-price" }, [
              _vm._v(
                "\n      " +
                  _vm._s(_vm._f("price")(_vm.price.basePrice)) +
                  "\n    "
              )
            ])
          : _vm._e(),
        _c(
          "div",
          { class: ["price price-rub", { discount: _vm.isDiscount }] },
          [
            _vm._v(
              "\n      " +
                _vm._s(
                  _vm._f("price")(
                    _vm.price.discountPrice || _vm.price.basePrice
                  )
                ) +
                "\n    "
            )
          ]
        )
      ]),
      _vm.product.availableOn
        ? _c("div", { staticClass: "item-access" }, [
            _c("span", [_vm._v("Можно забрать")]),
            _vm._v(
              " " +
                _vm._s(
                  _vm._f("date")(_vm.product.availableOn, { showYear: true })
                ) +
                "\n  "
            )
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }